<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-being-of-me">
<h1>The Being of Me</h1>
<p>Poems, like love letters written in the sand, cannot be taken away by the ripples of a wave.</p>
<p>Family, the hub of all life. Family means to share, to love, to forgive. We stand together, love as one, if one had misfortune, we all felt the pain. One who is without family is without love; it is the meaning of life.</p>
<p>We all start in the same place, we all end in the same place, it is in the middle that counts.</p>
<p>Some of the following lines were taken from the song. Where do you start?</p>
<p>Music by Johnny Mandel, Lyrics by Marilyn and Alan Bergman.</p>
<p>The true story of my love was written in the form of poetry.</p>
<p>Where do you start? How do you separate the present from the past?</p>
<p>All the dreams and pictures that all came true.</p>
<p>Our lives were tangled like the branches of a vine that intertwined.</p>
<p>How do you deal with the things you thought would last?</p>
<p>With bits of memories scattered here and there.</p>
<p>I look around and don’t know where to start.</p>
<p>When you read these poems of love, you will be looking into the being me.</p>
<p>Her demise brought anger, sorrow, and tears, these many poems of love gave me peace. Other poems were of family and events.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?f72e91f0